import { useRef, useState } from 'react';
import { mutate } from 'swr';
import { addToCartFetcher } from '../../../../datafetchers/productPage';
import {
  addDeleteCartFillerProductCookie,
  deleteCartItemFromCookie,
  isProductInCartFillerCookies,
} from '../../../../Utils/CartUtils';
import {
  getScreenName,
  getUserIsLoggedIn,
  getUserToken,
} from '../../../../Utils/helper';
import { cartItemsCookieSetter } from '../../../../Utils/productAction';
import {
  diaperCartFillerProductId,
  diaperNewOfferId,
  diaperOfferId,
} from '../Constants';
import { firecartFiller, UpdateQuantityEvent } from '../instrumentation';
import AddItemLoader from './AddItemLoader';
import { AddDeleteItem, CartButton } from './styled';
import { pushSameRouteMaternity } from '../../../../Utils/PaymentUtils/utils';
import { useRouter } from 'next/router';
import Cookies from 'js-cookie';

import { fireEvent } from '../../../../Utils/fireEvent';

export default function AddDeleteCartButtons(props) {
  const {
    itemData,
    setSnackBarMessage,
    offerId,
    showCartFillerStrip,
    offerListFetcher,
    getPriceSectionCart,
    isB2G1SkuAdded,
    isConsultationProduct,
  } = props;
  const { quantity, id, showAddToCart } = itemData;
  let B2G1Freebieitems = [];
  if (isB2G1SkuAdded) {
    B2G1Freebieitems = Cookies.get('b2g1_locked_products') || '';
    if (B2G1Freebieitems) {
      B2G1Freebieitems = B2G1Freebieitems.split(',');
    }
  }
  const [showLoader, setShowLoader] = useState('');
  const lastUpdateStatus = useRef('');
  const nonFreeItem = itemData?.price !== 0;
  const enableDeleteForFreeItem =
    offerId === diaperOfferId || offerId == diaperNewOfferId;
  const router = useRouter();
  // const canChangeQuanity = nonFreeItem || BOGO_OFFER_CODES.includes(offerId);
  const canChangeQuanity = nonFreeItem;

  const changeQuantityHandler = async (type, e) => {
    e.stopPropagation();
    if (lastUpdateStatus.current === 'pending') {
      return;
    }
    if (canChangeQuanity || (type === 'delete' && enableDeleteForFreeItem)) {
      lastUpdateStatus.current = 'pending';
      if (quantity === 5 && type === '+') {
        setSnackBarMessage('Item quanity is limited to 5 per order');
        lastUpdateStatus.current = 'completed';
        return null;
      }
      setShowLoader(type);
      const isCartFillerProduct = isProductInCartFillerCookies(itemData?.id);
      // if (type !== "delete") {
      UpdateQuantityEvent(itemData, type, quantity, isCartFillerProduct);
      // }
      //if (getUserIsLoggedIn()) {
      const webUserId = Cookies.get('web_user_id_react');
      const changeReq = {
        login: getUserIsLoggedIn(),
        product: itemData?.id,
        cart_id: itemData?.cart_id,
        web_fcm_token: getUserToken(),
        offer: offerId ? offerId : null,
        web_user_id: webUserId,
      };
      changeReq['add_quantity'] = type === '+';
      changeReq['less_quantity'] = type === '-';
      changeReq['remove'] = type === 'delete';
      await addToCartFetcher(changeReq);
      //  }
      switch (type) {
        case '+':
          cartItemsCookieSetter(itemData?.id, true);
          if (isCartFillerProduct) {
            addDeleteCartFillerProductCookie('add', itemData?.id);
          }
          break;
        case '-':
        case 'delete':
          if (diaperCartFillerProductId?.includes(itemData?.id?.toString())) {
            Cookies.remove('diaper_filler');
          }
          deleteCartItemFromCookie(itemData?.id);

          addDeleteCartFillerProductCookie('delete', itemData?.id);
          showCartFillerStrip
            ? firecartFiller(' removed_cart_filler_item', itemData)
            : null;
          break;
      }
      await mutate('/api/getNewCartAmountOfUserWeb');
      lastUpdateStatus.current = 'completed';
      setShowLoader('');
    }
    await offerListFetcher();
  };

  const addFreeConsultationToCart = async (type, e) => {
    e.stopPropagation();
    if (lastUpdateStatus.current === 'pending') {
      return;
    }
    lastUpdateStatus.current = 'pending';
    setShowLoader(type);
    const webUserId = Cookies.get('web_user_id_react');
    const changeReq = {
      login: getUserIsLoggedIn(),
      product: itemData?.id,
      cart_id: itemData?.cart_id,
      web_fcm_token: getUserToken(),
      offer: offerId ? offerId : null,
      web_user_id: webUserId,
      filler_type: '5',
    };
    changeReq['add_quantity'] = type === '+';
    changeReq['less_quantity'] = type === '-';
    changeReq['remove'] = type === 'delete';
    await addToCartFetcher(changeReq);
    await mutate('/api/getNewCartAmountOfUserWeb');
    lastUpdateStatus.current = 'completed';
    setShowLoader('');
  };

  return isConsultationProduct ? (
    showLoader ? (
      <div
        style={{
          width: '100px',
          marginTop: '10px',
          marginBottom: '5px',
        }}
      >
        <AddItemLoader />
      </div>
    ) : showAddToCart ? (
      <button
        className="addForFreeBtn"
        onClick={(e) => addFreeConsultationToCart('+', e)}
      >
        <span>+</span>
        <div>ADD FOR FREE</div>
      </button>
    ) : (
      <button
        className="addForFreeBtn"
        onClick={(e) => addFreeConsultationToCart('delete', e)}
        style={{ padding: '7px 5px' }}
      >
        <div>REMOVE</div>
      </button>
    )
  ) : (
    <CartButton>
      <AddDeleteItem showCartFillerStrip={showCartFillerStrip}>
        <div
          className={`delete_items common_button ${
            !canChangeQuanity && !enableDeleteForFreeItem ? 'disabled' : ''
          } `}
          onClick={(e) =>
            changeQuantityHandler(quantity > 1 ? '-' : 'delete', e)
          }
        >
          {showLoader === '-' || showLoader === 'delete' ? (
            <AddItemLoader />
          ) : (
            <div className="flexImg">
              <img
                src={
                  quantity > 1
                    ? '/images/minusblack.svg'
                    : '/images/deleteblack.svg'
                }
                alt="button"
              />
              {diaperCartFillerProductId?.includes(itemData?.id?.toString()) ||
              B2G1Freebieitems?.includes(id.toString()) ? (
                <button
                  className="sizeBtn"
                  onClick={(e) => {
                    e.stopPropagation();
                    fireEvent({
                      category: 'clicked_cta',
                      parent: 'items in cart',
                      cta: 'change size',
                      sku_id: itemData?.id,
                      screen_name: getScreenName(),
                    });
                    pushSameRouteMaternity(
                      router,
                      isB2G1SkuAdded
                        ? 'diaperSizeB2G1Popup'
                        : 'diaperSizePopup',
                      {
                        id: itemData.id,
                        cart_id: itemData.cart_id,
                        offer_id: offerId,
                      },
                    );
                  }}
                >
                  Change Size
                </button>
              ) : (
                <></>
              )}
            </div>
          )}
        </div>

        {!showCartFillerStrip && !B2G1Freebieitems?.includes(id.toString()) ? (
          <>
            <div className="total_items common_button">{quantity}</div>
            <div
              className={`plus_items common_button ${
                canChangeQuanity ? '' : 'disabled'
              }`}
              onClick={(e) => changeQuantityHandler('+', e)}
            >
              {showLoader === '+' ? (
                <AddItemLoader />
              ) : (
                <img src="/images/plusblack.svg" alt="plusblack" />
              )}
            </div>
          </>
        ) : null}
      </AddDeleteItem>
      {/* {showCartFillerStrip ? getPriceSectionCart() : null} */}
    </CartButton>
  );
}
